import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  Input,
  PageHeader,
  Select,
  Button,
  Switch,
  message,
} from "antd";
import R2Footer from "../../../components/Footer";
import EmployeeService from "../../../services/EmployeeService";
import styles from "./style.module.scss";
import "./style.scss";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import PosService from "../../../services/PosService";

const { Content } = Layout;
const { Option } = Select;

const PosServerLogin = () => {
  const [state, setState] = useState({});
  const [type, setType] = useState("Server");
  const [host, setHost] = useState([]);
  const adminRestaurant = useSelector((state) => state.admin);
  const history = useHistory();
  const [employees, setEmployees] = useState([]);
  const [employeesServer, setEmployeesServer] = useState([]);
  const [employeesHost, setEmployeesHost] = useState([]);

  // useEffect(() => {
  //   (async()=>{
  //     const data = await EmployeeService.getAllServerAndHosts(adminRestaurant)
  //     setHost(data?.host)
  //   })()
  // }, [])

  useEffect(() => {
    getEmployees();
  }, [adminRestaurant]);

  const getEmployees = async () => {
    const data = await EmployeeService.getEmployeesByEmployeeType("SERVER");
    const dataHost = await EmployeeService.getEmployeesByEmployeeType("HOST");
    if (data) {
      setEmployeesServer(data.employees);
      setEmployees(data.employees);
    }

    if (dataHost) setEmployeesHost(dataHost.employees);
  };

  const handleChange = (key, value, data) => {
    const filterByRes = data?.data?.restaurant_roles.find(
      (item) => item.restaurant_id === adminRestaurant
    );

    setState({
      name: value,
      code: filterByRes?.employee_code,
      id: data?.data?.id,
    });
    localStorage.setItem("LoginId", data?.data?.id);
    // if(key==='name') {
    //   setState({ ...state, [key]: host[value].name, 'code': host[value].employee_code  });
    // }else{
    //   setState({ ...state, [key]: value });
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // try {
    //   const res = await EmployeeService.employeeLogin({
    //      employee_code: state.code,
    //      restaurant_id: adminRestaurant
    //   });
    //   // const resEmp = PosService.posEmployeeTable(adminRestaurant,state.code)
    //   if(res.id) {
    //     message.success('LoggedIn Successfully');
    //   }
    // } catch (error) {
    //   message.error('Error in LoggedIn.');
    // }
    if (state.code) {
      if (type == "Server") history.push(`/pos/pos-table?id=${state.id}`);
      else history.push(`/pos/seating-management`);
    }
  };

  const onChange = (checked) => {
    // setEmployees([])
    // setEmployees(employeesHost)
    if (checked) {
      setEmployees(employeesServer);
      setType("Server");
    } else {
      setEmployees(employeesHost);
      setType("Host");
    }
  };

  return (
    <Layout className="u-page-layout">
      <Content className="w-full page-padding">
        <Space className="w-full" direction="vertical">
          <PageHeader className="page-header" title={"Login"} />
          <form
            className="site-layout-background text-left p-1"
            onSubmit={handleSubmit}
          >
            <div className="login-header">
              <h3 style={{ display: "inline" }} className={styles.login_card}>
                Login
              </h3>
              <div>
                <span
                  className={
                    type == "Host" ? "checked-highlight" : "checked-default"
                  }
                >
                  Host
                </span>
                <Switch defaultChecked onChange={onChange} />
                <span
                  className={
                    type == "Server" ? "checked-highlight" : "checked-default"
                  }
                >
                  Server
                </span>
              </div>
            </div>
            <div className="mb-1">
              <label className="d-block">
                {type == "Host" ? "Hosts" : "Server"} Name
              </label>
              <Select
                value={state.name}
                className="w-full"
                placeholder={type == "Host" ? "Hosts Name" : "Server Name"}
                // disabled={!type}
                name={"name"}
                onChange={(v, event) => handleChange("name", v, event)}
              >
                {employees &&
                  employees.map((val, index) => {
                    return (
                      <Option data={val} key={val.id} value={val.id}>
                        {val.name}
                      </Option>
                    );
                  })}
              </Select>
            </div>
            <div className="mb-1">
              <label>{type == "Host" ? "Hosts" : "Server"} Code</label>
              <Input
                placeholder={type == "Host" ? "Hosts Code" : "Server Code"}
                name="code"
                value={state.code}
                disabled
                className="code-input"
                onChange={(e) => {
                  handleChange("code", e.target.value);
                }}
              />
            </div>
            <div className="login-btn">
              <Button
                htmlType="submit"
                className="mt-1 pos-login"
                type="primary"
              >
                Login
              </Button>
            </div>
          </form>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

export default PosServerLogin;
